var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-modal',{attrs:{"okText":"确定","cancelText":"取消","title":"修改菜单"},on:{"ok":_vm.comfirm},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[[_c('a-form',{ref:"collectionForm",attrs:{"form":_vm.form}},[_c('a-form-item',{attrs:{"label":"订单号"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
						'orderid',
						{
						  initialValue: _vm.record.data.orderid,
						  rules: [{ required: true, message: `请填写名称`, whitespace: true }],
						},
					  ]),expression:"[\n\t\t\t\t\t\t'orderid',\n\t\t\t\t\t\t{\n\t\t\t\t\t\t  initialValue: record.data.orderid,\n\t\t\t\t\t\t  rules: [{ required: true, message: `请填写名称`, whitespace: true }],\n\t\t\t\t\t\t},\n\t\t\t\t\t  ]"}],attrs:{"disabled":""}})],1),_c('a-form-item',{attrs:{"label":"价格"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
						'price',
						{
						  initialValue: _vm.record.data.amount,
						  rules: [{ required: true, message: `请填写名称`, whitespace: true }],
						},
					  ]),expression:"[\n\t\t\t\t\t\t'price',\n\t\t\t\t\t\t{\n\t\t\t\t\t\t  initialValue: record.data.amount,\n\t\t\t\t\t\t  rules: [{ required: true, message: `请填写名称`, whitespace: true }],\n\t\t\t\t\t\t},\n\t\t\t\t\t  ]"}],attrs:{"type":"number"}})],1)],1)]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }